import React from "react";
import Socials from "../commons/socials";
import Link from "../commons/link";
import { useResources } from "../../utility/use-resources";
import NewsletterBoundLink from "../../utility/newsletter-bound-link";

const Footer = (props) => {
  const [r] = useResources("footer");
  return (
    <footer>
      <div className="footer-columns">
        <div className="left-column">
          <div className="socials-newsletter">
            <Socials />
            <div className="newsletter-sub">
              <NewsletterBoundLink alwaysOpen url="#">
                <i className="far fa-envelope"></i>
                <p className="small">{r('newsletterSubscription')}</p>
              </NewsletterBoundLink>
            </div>
          </div>
          <ul className="copyrights">
            {r("links")?.map((link) => (
              <li>
                <p className="small">
                  <Link to={link.url}>{link.name}</Link>
                </p>
              </li>
            ))}
            <li className="block">
              <p className="small">
                {r("disclaimer")}
              </p>
            </li>
            <li className="block">
              <p className="small">
                &copy;{new Date().getFullYear()} {r("copyright")}
              </p>
            </li>
          </ul>
        </div>
        <div className="right-column">
          <ul className="certifications">
            {r('seals')?.map(seal => 
              <li>
                <a href={seal.link} target="_blank">
                  <img src={seal.image?.[0]?.downloadURL} />
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
      <ul className="certifications">
        <li>
          <a href={r("norte2020.file")?.[0]?.downloadURL} target="_blank">
            <img src={r("norte2020.image")?.[0]?.downloadURL} />
          </a>
        </li>
        {r('norte2020secondary.file')?.[0]?.downloadURL && r('norte2020secondary.image')?.[0]?.downloadURL && (
          <li>
            <a href={r("norte2020secondary.file")?.[0]?.downloadURL} target="_blank">
              <img src={r("norte2020secondary.image")?.[0]?.downloadURL} />
            </a>
          </li>
        )}
      </ul>
    </footer>
  );
};
export default Footer;
